// extracted by mini-css-extract-plugin
module.exports = {"tenant-avatar":"tenant-avatar___1vXMR","highlighted":"highlighted___3fZWt"};